<template>
  <section class="document-form">
    <div class="form-item">
      <span>Policyholder HKID</span>
      <file-container
        :edit="true"
        :fileData="formData.id_type_pic"
        :otherData="{
          target: 'id_type_pic'
        }"
        titleName= "Policyholder HKID"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
    <div
      class="form-item">
      <span>Insured Student HKID</span>
      <file-container
        :edit="true"
        :fileData="{
          thumb_url:student_info.id_type_pic_thumb_url,
          url:student_info.id_type_pic_url,
          client_name:student_info.id_type_pic_path_id
        }"
        :otherData="{
          target: 'student_id_type_pic',
          type: 'student_id_type_pic'
        }"
        titleName= "Insured Student HKID"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>

    <div
      v-if="hasAcc"
      class="form-item">
      <span >Accompanying Parent or Guardian HKID</span>
      <file-container
        :edit="true"
        :fileData="{
          thumb_url:acc_parent_info.id_type_pic_thumb_url,
          url:acc_parent_info.id_type_pic_url,
          client_name:acc_parent_info.id_type_pic_path_id
        }"
        :otherData="{
          target: 'acc_parent_id_type_pic  ',
          type: 'acc_parent_id_type_pic  '
        }"
        titleName= "Accompanying Parent or Guardian HKID"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
  </section>
</template>
<script>
export default {
  name: 'TravelDocumentForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        id_type_pic: {},
        contract: {},
        // cert_of_inc_pic: {},
        other_file: [],
        student_info:{},
        acc_parent_info:{}
      }
    }
  },
  computed:{
    student_info() {
      let {student_info}= this.formData||{}
      return student_info||{}
    },
    acc_parent_info() {
      let {acc_parent_info}= this.formData||{}
      return acc_parent_info||{}
    },
    hasAcc() {
      let {benefits=[]}= this.formData||{}
      return benefits.includes(2)
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(JSON.stringify(val) != '{}') {
          if(this.formDataLock !== this.oldFormDataLock) {
            // 觸發更新就賦值，避免二次更新
            this.oldFormDataLock = this.formDataLock
            Object.keys(this.formData).some(key => {
              if(key in val) {
                this.formData[key] = JSON.parse(JSON.stringify(val[key]))
              }
            })
          }
        }
      }
    }
  },
  methods: {
    submitForm() {
      const { id_type_pic, contract } = this.formData
      let params = JSON.parse(JSON.stringify(this.formData))
      if(id_type_pic) {
        params.id_type_pic_path = id_type_pic.path
        params.id_type_pic_path_id = id_type_pic.id
      }
      return params
    },
    handlerDeleteFile(otherData) {
      const { target, index = '',type } = otherData
      if(index === '') {
        if(type === 'student_id_type_pic') {
          this.$set(this.formData.student_info, 'id_type_pic_url', '')
          this.$set(this.formData.student_info, 'id_type_pic_thumb_url', '')
          this.$set(this.formData.student_info, 'id_type_pic_path_id', '')
          this.$set(this.formData.student_info, 'client_name', '')
        }
        else if(type === 'acc_parent_id_type_pic  ') {
          const { id, name, thumb_url, url } = data
          this.$set(this.formData.acc_parent_info, 'id_type_pic_url', '')
          this.$set(this.formData.acc_parent_info, 'id_type_pic_thumb_url', '')
          this.$set(this.formData.acc_parent_info, 'id_type_pic_path_id', '')
          this.$set(this.formData.acc_parent_info, 'client_name', '')
        }
        else{
          this.formData[target] = null
        }
      } else {
        this.formData[target].splice(index, 1)
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, type, index = '' } = otherData
      if(type === 'other') {
        if(!this.formData[target]) {
          this.formData[target] = []
        }
        this.formData[target].push(data)
      }
      if(type === 'student_id_type_pic   ') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.student_info, 'id_type_pic_url', url)
        this.$set(this.formData.student_info, 'id_type_pic_thumb_url', thumb_url)
        this.$set(this.formData.student_info, 'id_type_pic_path_id', id)
        this.$set(this.formData.student_info, 'client_name', name)
      }
      if(type === 'acc_parent_id_type_pic  ') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.acc_parent_info, 'id_type_pic_url', url)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_thumb_url', thumb_url)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_path_id', id)
        this.$set(this.formData.acc_parent_info, 'client_name', name)
      }
      else if(index === '') {
        this.$set(this.formData, target, data)
      } else {
        this.$set(this.formData[target], index, data)
      }
    }
  }
}
</script>